<nav class="afb" aria-label="breadcrumb">
    <ol class="afb__list">
        <li class="afb__item" *ngFor="let item of items; let last = last">
            <a *ngIf="item.url && !last" [routerLink]="[item.url]" class="afb__link">{{ item.label }}</a>
            <span *ngIf="!item.url || last" class="afb__current" [attr.aria-current]="last ? 'page' : null">{{ item.label }}</span>
            <mat-icon *ngIf="!last" class="afb__chevron">chevron_right</mat-icon>
        </li>
    </ol>
</nav>
